
import setting from '../../server/settings'
import Badge from 'vux/src/components/badge/index.vue'
import Loading from 'vux/src/components/loading/index.vue'
import Alert from 'vux/src/components/alert/index.vue'

import { mapState ,mapMutations} from 'vuex'
import api from "~api";
import axios from 'axios'
import QRcode from 'qrcodejs2';
export default {
name: "home",
components: {
Badge,Loading,Alert
},
computed: mapState({
stu_name: (state) => state.stu_name,
stu_num: (state) => state.stu_num,
stu_major: (state) => state.stu_major,
open_id: (state) => state.open_id,
nickname: (state) => state.nickname,
headImgUrl: (state) => state.headImgUrl,
}),
data(){
return{

baseurl: "http://yxxt.xijing.edu.cn",
stunum:'',
localimg:'',
localname:'',
openid:'',
showChangeMajor:false,
bindBool: false,
showBxf: false,
showBxfList: [],
shouHome: '',
show2: false,
iss: false,
currPost:'',// 当前岗位
apps:[],
stateapps:[],
enrollType: '',
type:''
}
},
mounted(){
var _this = this;

_this.stunum = _this.$store.state.stu_num;
_this.idcard = _this.$store.state.stu_idcard;
_this.localimg = window.localStorage.getItem('headImgUrl');
_this.localname = window.localStorage.getItem('nickname');

_this.openid = _this.$store.state.open_id?_this.$store.state.open_id:window.localStorage.getItem('openId');
var app = _this.$route.params.app;

if(_this.openid){

api.post('/api/binding/findstu', {"openId": _this.openid}).then(function (response) {
var data = response.data;
if (response.status == 200){
var info = data.results;
if(info == null ){
_this.$msgbox('温馨提示：',"请先绑定考生号或学号");
window.localStorage.removeItem("stuCode");
window.localStorage.removeItem("stunum");
window.localStorage.removeItem("majorId");
window.localStorage.removeItem("grade");
_this.$vux.loading.hide()
}else{
if(info.type === '3'){

_this.type = info.type;
_this.changeName(info.userName);
_this.changeStuNumber(info.userCode);
_this.changeMajor(info.deptName);
_this.changeBind(true);
_this.currPost = info.post;
_this.bindBool = _this.$store.state.isbind;
window.localStorage.setItem("userCode",info.userCode);
window.localStorage.setItem("userId",info.userId);
window.localStorage.setItem("token",data.token);
_this.getData()
}else{
console.log(info,'lllllllllllll')

_this.iss =true
const isNew = info.enterSchoolYear.toString() === new Date().getFullYear().toString()?1:2; 
_this.shouHome = info.enterSchoolYear.toString() === (new Date().getFullYear()).toString()?true:true

_this.showChangeMajor = (info.enterSchoolYear.toString() === new Date().getFullYear().toString()) && info.enrollType === '2'? true : false

_this.changeName(info.name);
_this.changeStuNumber(info.stuNumber);
_this.changePhone(info.telephone);
_this.changeMajor(info.majorName);
_this.changeIdcard(info.idCard);
_this.changeBind(true);
_this.bindBool = _this.$store.state.isbind;
_this.getData()
window.localStorage.setItem("stuCode",info.stuCode);

window.localStorage.setItem("isNew",isNew);

window.localStorage.setItem("stunum",info.stuNumber);

window.localStorage.setItem("majorId",info.majorId);
window.localStorage.setItem("grade",info.grade2);

window.localStorage.setItem("token",data.token);
window.localStorage.setItem("stuIsReport",data.stuIsReport);

window.localStorage.setItem("enrollType",info.enrollType);
_this.enrollType = info.enrollType;
_this.$vux.loading.hide()
}
}
}else {
_this.changeBind(false);
_this.bindBool = _this.$store.state.isbind;
window.localStorage.removeItem("stuCode");
window.localStorage.removeItem("stunum");
window.localStorage.removeItem("majorId");
window.localStorage.removeItem("grade");
window.localStorage.removeItem("userCode");
window.localStorage.removeItem("userId");
_this.getData()
_this.$vux.loading.hide()
}
})
}else{

window.localStorage.removeItem('access_token');
}
},
created(){
this.getData()
},
methods:{
getData(){
var param = {
"appId": setting.appid,
"type": "1", //九宫格应用
"status": "0",  //状态：0启用 1停用
"startTime": new Date()
};
var param1 = {
"appId": setting.appid,
"type": "0", //广告栏应用
"status": "0",  //状态：0启用 1停用
"startTime": new Date()
};

if(window.localStorage.getItem("stuCode")==null || window.localStorage.getItem("stuCode")==""){
if(window.localStorage.getItem("userCode")==null || window.localStorage.getItem("userCode")==""){
param['menu'] = '0';
param1['menu'] = '0';
}else{
param['menu'] = '2';
param1['menu'] = '2';
}
}else{
param['menu'] = '1';
param1['menu'] = '1';
}
this.apps = [];
axios.post('http:'+setting.mpmanageback+'/wx/app/selectAllApp',param).then( res=>{
if(res.data.applicationList!=null){
for(var i=0;i<res.data.applicationList.length;i++){
if(res.data.applicationList[i].labelName=='我的常用'){
const lists = res.data.applicationList[i].list;
const showApp = [];
let showAppStudent = [];
if(this.currPost){
lists.forEach((item)=>{
if(item.menu == '0'){
showApp.push(item);
}
if(this.currPost.indexOf('宿管') != -1){
if(item.url == 'scanCodes'){
showApp.push(item);
}
}
if(this.currPost.indexOf('咨询老师') != -1){

}
if(this.currPost.indexOf('审核老师') != -1){
if(item.url == 'checkReduce' || item.url == 'checkloan'){
showApp.push(item);
}
}
if(this.currPost.indexOf('导员') != -1){

}
})
}else {
lists.forEach((item)=> {
if (item.menu == '0') {
showApp.push(item);
}
})
}
if(this.iss && !this.showChangeMajor ){

lists.map((item)=>{
if(item.url !=='applicationProfessionalTransfer'){
showAppStudent.push(item)
}
})
}else {
showAppStudent = lists;
}


if(param.menu=='2'){
this.apps = showApp;
}else if(param.menu=='1'){
this.apps = showAppStudent;
}else{
this.apps = lists;
}
this.showBxfList = this.apps.filter(item =>item.url === "recharge")

}
}
}
})
axios.post('http:'+setting.mpmanageback+'/wx/app/selectAllApp',param1).then( res=>{
if(res.data.applicationList!=null){
for(var i=0;i<res.data.applicationList.length;i++){
if(res.data.applicationList[i].labelName=='我的常用'){
this.stateapps = res.data.applicationList[i].list;
}
}
}
})
},
binding(){
var _this = this;
var app = _this.$route.params.app;
if(_this.openid){
if(app == undefined){
_this.$router.replace('/Login');
}else{
_this.$router.replace({name: 'Login', params:{app:app}});
}

}else{
window.localStorage.removeItem('access_token');
if(app == undefined){
_this.$router.replace('/Login');
}else{
_this.$router.replace({name: 'Login', params:{app:app}});
}
}
},
unbinding(){
var _this = this;
_this.$vux.loading.show({
text: '加载中，请稍候！'
})
var param = {};
if(_this.type == '3'){
param = {
"userCode": window.localStorage.getItem("userCode"),
"type": "3"
};
}else{
param = {
"stuCode": window.localStorage.getItem("stuCode"),
"idCard":_this.$store.state.stu_idcard,
"type": ""
};
}
api.post('/api/binding/cleanOpenId',param)
.then(function (response) {
if(response.status==200){
if(response.data.results == 1){

_this.changeStuNumber('');
_this.changeIdcard('');
_this.changeMajor('');
_this.changeBind(false);
_this.bindBool = false;
_this.changeName('');
window.localStorage.removeItem("stuCode");
window.localStorage.removeItem("stunum");
window.localStorage.removeItem("majorId");
window.localStorage.removeItem("grade");
window.localStorage.removeItem("userCode");
window.localStorage.removeItem("userId");
window.localStorage.removeItem("token"); 
window.localStorage.removeItem("stuIsReport"); 

window.localStorage.clear()


_this.getData()
}else{
_this.$msgbox('温馨提示：',"解绑失败");
}
}else{
_this.$msgbox('温馨提示：',"系统故障，请联系管理员");
}
_this.$vux.loading.hide()
})
},
viewnotice(){

},
searchscore(url){
var _this = this;
if(window.localStorage.getItem("stuCode")==null || window.localStorage.getItem("stuCode")==""){
if(window.localStorage.getItem("userId")!=null && window.localStorage.getItem("userId")!=""){
_this.$router.push({name: url})
}else{
_this.$msgbox('温馨提示：',"请先绑定学号或考生号！");
_this.$vux.loading.hide();

}
}else{
if(url.indexOf("http")>=0){




window.open(url, '_self');

}else {
if(url=="welcome"){
var stuIsReport = window.localStorage.getItem("stuIsReport");














if(stuIsReport == 'true'){
window.localStorage.setItem('stunum', _this.stu_num)
_this.$router.push({name: url, params:{stunum:window.localStorage.getItem("stuCode")}});
}else{
_this.$msgbox('温馨提示：',"线上迎新暂未开放！");
}




}else if(url=="QR"){
_this.mycode();
}else if(url=="myDormitory"){
_this.sushe();
}else if(url=="customer"){
_this.tc();
}else{
window.localStorage.setItem('stunum', _this.stu_num)
_this.$router.push({name: url, params:{stunum:window.localStorage.getItem("stuCode")}});
}
}
}
},
junxun(){
this.$router.push({name: 'militaryTrainingClothing', params:{stunum:window.localStorage.getItem("stuCode")}});
},
sushe(){
const _this = this;
if(window.localStorage.getItem("isNew")==="2"){
_this.$router.push({name: 'myDormitory', params:{stunum:window.localStorage.getItem("stuCode")}});
}else {
/*api.post('/api/fees/checkCurrentChargeInfo',{"stuCode": window.localStorage.getItem("stuCode")})
.then(function (response) {
if(response.data.msg==="1"){
_this.$router.push({name: 'myDormitory', params:{stunum:window.localStorage.getItem("stuCode")}});
}else {
_this.$msgbox('温馨提示：',"未完成缴费，请先缴费！");
}
})*/
api.post('/orientation/selectDormInfo',{"stuCode": window.localStorage.getItem("stuCode")}).then(function (response) {
if(response.status===200){
if(response.data.data!==null){
if(response.data.data.dormName!==null&&response.data.data.dormno!==null){
_this.$router.push({name: 'myDormitory', params:{stunum:window.localStorage.getItem("stuCode")}});
}else {
_this.$msgbox('温馨提示：',"您暂未选择宿舍，请先选择宿舍！");
}
}else {
_this.$msgbox('温馨提示：',"请等待分配宿舍");
}
}else {
_this.$msgbox('温馨提示：',"网络错误请稍后再试");
}
})
}
},
mycode(){
const _this = this;
api.post('/api/binding/checkStuRegStatus',{"stuCode": window.localStorage.getItem("stuCode")})
.then(function (response) {
if(response.data.msg==="1"){
if(window.localStorage.getItem("enrollType")!=='1'){
api.post('/orientation/selectDormInfo',{"stuCode": window.localStorage.getItem("stuCode")}).then(function (response) {
if(response.status===200){
if(response.data.data!==null){
if(response.data.data.dormName!==null&&response.data.data.dormno!==null){
var par ={
stuCode:window.localStorage.getItem("stuCode")
}
_this.show2=true
new QRcode(document.getElementById("qrcode"), JSON.stringify(par));
}else {
_this.$msgbox('温馨提示：',"您暂未选择宿舍，请先选择宿舍！");
}
}else {
_this.$msgbox('温馨提示：',"请等待分配宿舍");
}
}else {
_this.$msgbox('温馨提示：',"网络错误请稍后再试");
}
})
}else {

var par ={
stuCode:window.localStorage.getItem("stuCode")
}
_this.show2=true
new QRcode(document.getElementById("qrcode"), JSON.stringify(par) );
}
}else {
_this.$msgbox('温馨提示：',"来校入住宿舍使用，人证核验身份后显示！");
}
})

/*  api.post('/api/fees/checkCurrentChargeInfo',{"stuCode": window.localStorage.getItem("stuCode")})
.then(function (response) {
if(response.data.msg==="1"){
api.post('/api/binding/checkStuRegStatus',{"stuCode": window.localStorage.getItem("stuCode")})
.then(function (response) {
if(response.data.msg==="1"){
if(window.localStorage.getItem("enrollType")!=='1'){
api.post('/orientation/selectDormInfo',{"stuCode": window.localStorage.getItem("stuCode")}).then(function (response) {
if(response.status===200){
if(response.data.data!==null){
if(response.data.data.dormName!==null&&response.data.data.dormno!==null){
var par ={
stuCode:window.localStorage.getItem("stuCode")
}
_this.show2=true
new QRcode(document.getElementById("qrcode"), JSON.stringify(par));
}else {
_this.$msgbox('温馨提示：',"您暂未选择宿舍，请先选择宿舍！");
}
}else {
_this.$msgbox('温馨提示：',"请等待分配宿舍");
}
}else {
_this.$msgbox('温馨提示：',"网络错误请稍后再试");
}
})
}else {

var par ={
stuCode:window.localStorage.getItem("stuCode")
}
_this.show2=true
new QRcode(document.getElementById("qrcode"), JSON.stringify(par) );
}
}else {
_this.$msgbox('温馨提示：',"来校入住宿舍使用，人证核验身份后显示！");
}
})

}else {
_this.$msgbox('温馨提示：',"未完成缴费，请先缴费！");
}
})*/
},
scanCode(){
const _this = this;
this.$router.push({name: 'scanCodes', params:{stunum:window.localStorage.getItem("stuCode")}});
},
dormitoryInformation(){
const _this = this;
this.$router.push({name: 'dormitoryInformation', params:{stunum:window.localStorage.getItem("stuCode")}});
},
applicationProfessionalTransfer(){
this.$router.push({name: 'applicationProfessionalTransfer', params:{stunum:window.localStorage.getItem("stuCode")}});
},
tc  (){
api.post('/api/binding/kfSendMsg',{"stuCode": window.localStorage.getItem("stuCode")}).then(function (response) {
})
WeixinJSBridge.invoke('closeWindow',{},function(res){
});
},
...mapMutations(['changeBind','changeName','changeStuNumber','changePhone','changeMajor','changeIdcard','changeOpen_id','changeNickname','changeHeadImgUrl']),
}
}



// WEBPACK FOOTER //
// ./src/components/home.vue